import * as React from 'react'

export const OneDayCalendarIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5 0.5C5.53125 0.5 6 0.96875 6 1.5V2.5H10V1.5C10 0.96875 10.4375 0.5 11 0.5C11.5312 0.5 12 0.96875 12 1.5V2.5H13.5C14.3125 2.5 15 3.1875 15 4V5.5H1V4C1 3.1875 1.65625 2.5 2.5 2.5H4V1.5C4 0.96875 4.4375 0.5 5 0.5ZM1 6.5H15V15C15 15.8438 14.3125 16.5 13.5 16.5H2.5C1.65625 16.5 1 15.8438 1 15V6.5ZM3.5 8.5C3.21875 8.5 3 8.75 3 9V11C3 11.2812 3.21875 11.5 3.5 11.5H12.5C12.75 11.5 13 11.2812 13 11V9C13 8.75 12.75 8.5 12.5 8.5H3.5Z"
        fill="currentColor"
      />
    </svg>
  )
}
